import { Controller } from '@hotwired/stimulus'

export default class extends Controller {
  static targets = ['startDate', 'endDate']

  setStartDate (e) {
    const { date } = e.detail
    const startDate = date.format('MM/DD/YYYY')

    this.endDateTarget.setAttribute('data-easepick-lock-min-date', startDate)

    this.#adjustEndDate(startDate)
    this.#easepickController(this.endDateTarget).reload()
  }

  #easepickController (element) {
    return this.application.getControllerForElementAndIdentifier(element, 'easepick')
  }

  #adjustEndDate (startDate) {
    const endDate = this.endDateTarget.value.trim()
    if (!endDate) return

    if (startDate > endDate) {
      this.endDateTarget.value = startDate
    }
  }
}
